import React, { Component } from "react"
import {FormTable} from './FormTable'
import { famdyauth, famdydb } from '../../../service';
import swal from 'sweetalert';

export class Form extends Component {

    constructor(props) {
        super(props)
        this.state = {
            datas: [],
            text: '',
            last_id: ''
        }
        this.getData=this.getData.bind(this)
        this.createDare=this.createDare.bind(this)

    }

    componentDidMount(){
        this.getData()
    }

    componentDidUpdate(prevProps){
        if (this.props.match.params != prevProps.match.params) {
            this.getData()
        }

    }

    getData(){
        const { dare } = this.props.match.params
        famdydb.collection(dare).get().then((querySnapshot) => {
            const datas = querySnapshot.docs.map((doc) => {
                return { id: doc.id, ...doc.data() }
              })
            this.setState({datas})
            if(datas[datas.length-1])
            {
                this.setState({last_id: datas[datas.length-1].id})
            }
        }).catch((error) => {
            swal("Алдаа!", error, "error");
        })
    }

    createDare(){
        const { dare } = this.props.match.params
        const { text, last_id } = this.state
        var id = parseInt(last_id) + 1
        famdydb.collection(dare).doc(id.toString()).set({ like: 0, dislike: 0, text: text})
        .then(() => {
            swal("Амжилттай нэмлээ!", "", "success");

            this.setState({text: ''})
            this.getData()
        })
        .catch((error) => {
            swal("Алдаа!", error, "error");

        })
    }

    render() {
        const { dare } = this.props.match.params
        const { datas, text } = this.state
        return (
            <div className="main-content">
                <div className="my-4">
                    <div id="example_wrapper" className="">
                        <div className="table-responsive">
                            <table className="table example" id="example">
                                <thead>
                                    <tr>
                                        <th scope="col">Дугаар</th>
                                        <th scope="col">Шийтгэл</th>
                                        <th scope="col">like</th>
                                        <th scope="col">dislike</th>
                                        <th scope="col">Засах</th >
                                        <th scope="col">Устгах</th >
                                    </tr>
                                </thead>
                                <tbody>
                                    {datas.map((data, idx) =>
                                        <FormTable getData={this.getData} key = {idx} values={data} dare={dare}></FormTable>
                                    )}
                                </tbody>
                            </table>
                            <div className="row mt-5">
                                <div className="col-12">
                                    <h3>Шинээр шиитгэл нэмэх</h3>
                                </div>
                                <div className="col-8">
                                    <input
                                        name="text"
                                        type="text"
                                        id="text"
                                        className='form-control'
                                        onChange={(e) => this.setState({text: e.target.value})}
                                        value = {text}
                                    />
                                </div>
                                <div className="col-4" onClick={this.createDare}>
                                    <a className="btn btn-primary"> хадгалах</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}
